import { createFileRoute } from "@tanstack/react-router";

import { NewProjectPage } from "../../../features/projects/NewProjectPage";

export const Route = createFileRoute("/_app/projects/new")({
  component: NewProjectPage,
});
